<template>
  <v-card class="design-wrapper page" height="100%" v-if="campaign.steps">

    <campaigns-save-bar></campaigns-save-bar>

    <v-card
            class="edit-wrapper-outer no-radius elevation-0">
      <page></page>
    </v-card>
  </v-card>
</template>

<script>

import Campaigns from "@/views/CPanel/Business/Campaigns";
import page from "@/views/DesignPlatform/Campaigns/Page"
import {mapGetters} from "vuex";
import CampaignsSaveBar from "@/components/Campaigns/SaveBar";

export default {
  components: {
    Campaigns,
    page,
    CampaignsSaveBar
  },
  computed: {
    ...mapGetters([
      'screen_type',
      'campaign'
    ]),
  },
  watch: {
  },
  data() {
    return {
      frame_height: window.innerHeight
    }
  },
  created() {
    // document.documentElement.clientWidth = 400;
    // window.addEventListener("resize", this.calculateFrameHeight);
    // this.calculateFrameHeight();
  },
  destroyed() {
    // window.removeEventListener("resize", this.calculateFrameHeight);
  },
  methods: {
    calculateFrameHeight() {
      this.frame_height = (window.innerHeight - 54);
    }
  }
}
</script>

<style lang="scss">

.ls-image, .v-image__image {
  &:hover {
    cursor: pointer;
  }
}
.design-wrapper {
  .no-radius {
    border-radius: 0px;
  }

  .save-bar-wrapper {
    height: 48px;
  }

  .edit-wrapper {
    width: 100%;
    margin: auto;

    iframe {
      width: 100%;
    }
  }

  .edit-wrapper.size-tablet {
    width: 768px;
  }

  .edit-wrapper.size-mobile {
    width: 375px;
  }

  .mobile-bar {
    height: 36px;
  }
}
</style>